var cookieBanner = document.querySelector('.cookie');
var cookie_save = cookieBanner.querySelector('.js-cookie-save');
var cookie_accept = cookieBanner.querySelector('.js-cookie-accept');
var cookie_checkbox = cookieBanner.querySelector('.js-cookie-accept');

// Check if Cookie is already set
checkCookieOnLoad();


cookie_save.addEventListener('click', (e)=>{
	var trackingCheckbox = cookieBanner.querySelector('.js-cookie-tracking').checked;
	if (trackingCheckbox == true) {
		setCookie('cookie', 'statistic', '30');
	} else {
		setCookie('cookie', 'basic', '30');
	}
	location.reload();
});


cookie_accept.addEventListener('click', (e)=>{
	setCookie('cookie', 'statistic', '30');
	location.reload();
});



// Set Cookie
function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + "; " + expires;
}


// Get Cookie
function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i=0; i<ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0)==' ') c = c.substring(1);
    if (c.indexOf(name) == 0) return c.substring(name.length,c.length);
  }
  return "";
}

// Check Cookie
function checkCookieOnLoad() {
	switch (getCookie("cookie")) {
	  case "statistic":
  	 	cookieBanner.querySelector('.js-cookie-tracking').checked = true;
	    cookieBanner.style.display = "none";


			var _paq = window._paq = window._paq || [];
			/* tracker methods like "setCustomDimension" should be called before "trackPageView" */
			_paq.push(['trackPageView']);
			_paq.push(['enableLinkTracking']);
			(function() {
			  var u="//unternehmensbericht.boehringer-ingelheim.de/matomo/";
			  _paq.push(['setTrackerUrl', u+'matomo.php']);
			  _paq.push(['setSiteId', '1']);
			  var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
			  g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
			})();
				   
	    break;
	  case "basic":
	    cookieBanner.style.display = "none";
	    break;
	}






}



